import api from './api';

export const authService = {
  login: (email, password) => {
    return api.post('/admin/login', { email, password });
  },

  verifyOtp: (email, otp) => {
    return api.post('/admin/verify-otp', { email, otpCode: otp });
  },

  logout: () => {
    return api.post('/admin/logout');
  },

  validateToken: () => {
    return api.get('/admin/validate-token');
  },

  changePasswordInitiate: (currentPassword, newPassword, confirmPassword) => {
    return api.post('/admin/change-password/initiate', {
      currentPassword,
      newPassword,
      confirmPassword,
    });
  },

  changePasswordVerifyOtp: (otpCode, newPassword) => {
    return api.post('/admin/change-password/verify-otp', {
      otpCode,
      newPassword,
    });
  },

  getToken: () => localStorage.getItem('adminToken'),

  setToken: (token) => localStorage.setItem('adminToken', token),

  clearToken: () => localStorage.removeItem('adminToken'),

  isAuthenticated: () => !!localStorage.getItem('adminToken'),
};
